<template>
  <div class="home-page">
    <div class="row page-gap"></div>

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row">
            <WelcomeCard />
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="card home-card border-0">
        <div class="card-body home-card-body">
          <div class="home-title-wrap">
            <h3 class="home-title">{{ systemName }}</h3>
          </div>

          <div class="home-section community-section">
            <div class="section-header">
              <i class="fa fa-comments-o"></i>
              <span>ชุมชนช่างภาพ</span>
            </div>
            <p class="section-text">เข้าร่วม Line กลุ่มสำหรับช่างภาพ เพื่อพูดคุยและสอบถามข้อมูลได้ทันที</p>
            <div class="line-group-wrap">
              <a target="_blank" href="https://line.me/ti/g/cMVnKxrhFz">
                <img
                  width="200"
                  src="@/assets/images/running/line-group.jpg"
                  alt="line-group"
                  class="line-group-image"
                />
              </a>
            </div>
          </div>

          <div class="home-section tips-section">
            <div class="section-header">
              <span>คำแนะนำการตั้งค่ากล้อง เพื่อให้ไฟล์มีขนาดเหมาะสมและทำงานได้รวดเร็วขึ้น</span>
            </div>

            <div class="tips-block">
              <p>
                แนะนำให้ตั้งค่าคุณภาพภาพเป็น JPEG (BASIC, LOW, LIGHT, เบา) เพื่อลดขนาดไฟล์และช่วยให้อัปโหลดได้เร็วขึ้น
              </p>
              <ul>
                <li>
                  <a :href="websiteUrl + '/running-img/running-camera-setting-nikon.jpg'" target="_blank">Nikon JPEG (BASIC)</a>
                </li>
                <li>
                  <a href="https://support.usa.canon.com/kb/index?page=content&id=ART173768" target="_blank">Canon JPEG(LOW)</a>
                </li>
                <li>
                  <a :href="websiteUrl + '/running-img/running-camera-setting-sony.jpg'" target="_blank">Sony JPEG (LIGHT,เบา)</a>
                </li>
              </ul>
            </div>

            <div class="tips-block">
              <p>
                คำแนะนำการตั้งค่า Lightroom สำหรับ Export
                <u><a :href="websiteUrl + '/running-img/running-export-lr-setting.jpg'" target="_blank">ตัวอย่างการตั้งค่า</a></u>
              </p>
              <ul>
                <li>Quality:70</li>
                <li>Resolution: 70</li>
                <li>Image size: 4300px (Long Edge)</li>
              </ul>
            </div>
          </div>

          <div class="home-section support-section">
            <p class="support-line">
              <b>
                Logo RUNNING :
                <a href="https://drive.google.com/drive/folders/1KPxAwg10OEAjNfdwq9KD23UxXAj6ieIV?usp=sharing" target="_blank">RUNNING LOGO</a>
              </b>
              <i class="fa fa-heart support-heart"></i>
            </p>
            <p class="support-line">
              <b>
                ติดต่อสอบถามข้อมูลเพิ่มเติม หรือเปิดใช้งานระบบจำหน่ายภาพ:
                Line <a target="_blank" href="https://lin.ee/CBuSJCz">@running.in.th</a>
                หรือ
                <a target="_blank" href="tel:0904949989">0904949989</a>
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.home-page {
  background: radial-gradient(circle at top right, #eaf4ff 0%, #f8fbff 40%, #ffffff 100%);
  padding-bottom: 1rem;
}

.page-gap {
  height: 0.5rem;
}

.home-card {
  border-radius: 1rem;
  box-shadow: 0 12px 30px rgba(37, 62, 105, 0.08);
}

.home-card-body {
  padding: 1.5rem;
}

.home-title-wrap {
  margin-bottom: 1rem;
}

.home-title {
  margin-bottom: 0.25rem;
  font-weight: 700;
  color: #1c3256;
}

.home-subtitle {
  margin: 0;
  color: #60789d;
}

.home-section {
  border: 1px solid #e6edf7;
  border-radius: 0.9rem;
  background: #ffffff;
  padding: 1rem;
  margin-top: 1rem;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: #1c3256;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.section-text {
  margin-bottom: 0.75rem;
}

.line-group-wrap {
  display: flex;
  justify-content: center;
}

.line-group-image {
  border-radius: 0.8rem;
  box-shadow: 0 8px 18px rgba(24, 119, 242, 0.15);
}

.tips-block + .tips-block {
  margin-top: 1rem;
}

.tips-block p {
  margin-bottom: 0.5rem;
}

.tips-block ul {
  margin-bottom: 0;
}

.support-line {
  margin-bottom: 0.4rem;
}

.support-heart {
  font-size: 15px;
  color: red;
  margin-left: 0.3rem;
}

@media (max-width: 768px) {
  .home-card-body {
    padding: 1rem;
  }
}
</style>

<script>
import WelcomeCard from "./WelcomeCard.vue";

export default {
  data() {
    return {
      websiteUrl: process.env.VUE_APP_WEBSITE_URL,
      systemName: process.env.VUE_APP_SYSTEM_NAME,
    };
  },
  components: {
    WelcomeCard,
  },
};
</script>
